import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

type DialogStateType<T> = {
  isOpen: boolean
  isWithoutAnimation?: boolean
  data?: T
}

type NavigationStoreType = {
  settings: DialogStateType<null>
  sideMenu: DialogStateType<null>
  reportBug: DialogStateType<null>
  newLearningLesson: DialogStateType<null>
  addStudentQR: DialogStateType<{ qrCode: string | undefined }>
  learningActivityDetail: DialogStateType<{ id: string }>
}

const initialState: NavigationStoreType = {
  settings: { isOpen: false },
  sideMenu: { isOpen: false },
  reportBug: { isOpen: false },
  newLearningLesson: { isOpen: false },
  learningActivityDetail: { isOpen: false },
  addStudentQR: { isOpen: false, data: { qrCode: undefined } }
}

type DialogKeyType = keyof NavigationStoreType

const useStore = createWithEqualityFn<NavigationStoreType>(() => initialState, shallow)

export const dialogStateStore = {
  setIsOpen: <T>(key: DialogKeyType, data?: NavigationStoreType[DialogKeyType]['data'] | T): void => {
    useStore.setState({ [key]: { isOpen: true, isWithoutAnimation: false, data } })
  },
  setIsClosed: (key: DialogKeyType, replace?: false): void => {
    useStore.setState((prevState) => ({ ...prevState, [key]: { ...prevState[key], isOpen: false } }), replace)
  },

  clearStore: (): void => {
    useStore.setState(initialState)
  },
  useStore
}
